import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@client/lib/useSession';

interface RequireAuthProps {
  children: React.ReactNode;
}

/**
 * Renders children when authenticated, redirects to /login when anonymous,
 * and renders a loading state while the session check is in flight.
 *
 * The loading state is critical: it prevents flashing the login screen
 * while the session request is still pending.
 */
export function RequireAuth({ children }: RequireAuthProps) {
  const { status } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="require-auth-loading" role="status" aria-label="Loading">
        <div className="require-auth-spinner" aria-hidden="true" />
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
